/**
 * Function that transforms a date like YYYY-MM-DD to DD/MM/YYYY
 * @param {string} date Date with format YYYY-MM-DD
 */
export const formatDateToDDMMYYYY = (date: string) => {
  return date.split('-').reverse().join('/')
}
